import React, { Component } from "react";
import Spinner from "./uploadSpinner";
import Buttons from "./uploadButtons";
import { pushMessage } from "../../redux/actions/commonActions";
import Amplify from "aws-amplify";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Storage } from "aws-amplify";
import { API } from "aws-amplify";
import xlsx from "xlsx";
import encoding from "encoding-japanese";
import _ from "lodash";
import SQS from "aws-sdk/clients/sqs";

import { generatePublicChatbotSnippet } from "../../redux/actions/connectionActions";
import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
var detect = require("charset-detector");
var iconv = require("iconv-lite");

const config = require("../../app_configuration").CONFIGURATION[environment];

const apiRequestFixedParams = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

const UPLOADING_FILE = "Your data is uploading.";
const UPLOADED_FILE = "Your data has been successfuly uploaded.";
const UPLOAD_FAILED = "Your data upload has failed. Please try again or contact our support.";

class Uploader extends Component {
  state = {
    uploading: false,
    collection: null,
    msgId: null,
    polling: 10,
    files: []
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.collection !== null) {
      if (prevState.collection === null || (prevState.polling !== this.state.polling && this.state.polling !== 0)) {
        setTimeout(() => {
          this.SQSUploadPolling(this.state.collection);
        }, 20000);
      } else if (this.state.polling === 0) {
        this.props.pushMessage({
          message: UPLOADING_FILE,
          type: "success"
        });
        this.setState({ uploading: false, collection: null, polling: 10 });
      }
    }
  }

  onChange = e => {
    const files = Array.from(e.target.files);
    this.setState({ uploading: true });
    if (this.props.type === "faq-uploader") {
      let confirmed = window.confirm("This will erase all of your FAQ data. Are you sure?");
      if (!confirmed) {
        e.target.value = "";
        this.setState({ uploading: false, files: [] });
      } else {
        this.props
          .generatePublicChatbotSnippet()
          .then(res => {
            let msgId = Date.now();
            this.solrUpload(files[0], msgId, "faq-documents")
              .then(res => {
                this.setState({ collection: this.props.connection.publicChatbotProps.data.GUID, msgId: msgId });
                // res.json();
                console.log("Solr upload response", res);
                if (!res.error) {
                  this.props.pushMessage({
                    message: UPLOADING_FILE,
                    type: "success"
                  });
                } else {
                  this.props.pushMessage({
                    message: res.error.msg,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.setState({
                  uploading: false,
                  files: []
                });
                this.props.pushMessage({
                  message: error.message,
                  type: "error"
                });
              });
          })
          .catch(err => {
            console.log(err);
          });
      }
    } else if (this.props.type === "image-uploader") {
      const files = Array.from(e.target.files);
      const image = files[0];
      const image_key = Date.now() + "_" + image.name;
      Storage.put(image_key, files[0], {
        contentType: "application/octet-stream"
      }).then(response => {
        if (_.get(response, "key", false)) {
          const image_key = "https://s3.amazonaws.com/ev-pre-prod-profile-pics/public/" + response.key;
          this.props.updateConnectorImage(image_key);
          this.setState(
            {
              uploading: false,
              files
            },
            () => {
              this.props.pushMessage({
                message: "Image successfully uploaded.",
                type: "success"
              });
            }
          );
        }
      });
    } else if (this.props.type === "survey-uploader") {
      let confirmed = window.confirm("This will erase all of your survey questions. Are you sure?");
      if (!confirmed) {
        e.target.value = "";
        this.setState({ uploading: false, files: [] });
      } else {
        this.props
          .generatePublicChatbotSnippet()
          .then(res => {
            let lastUpdated = Date.now();
            this.solrUpload(
              files[0],
              lastUpdated,
              "survey-document",
              this.props.cognitoUser.attributes["custom:tenant"]
            )
              .then(res => {
                // res.json();
                console.log("Solr upload response", res);
                if (!res.error) {
                  this.props.pushMessage({
                    message: UPLOADED_FILE,
                    type: "success"
                  });
                  this.setState({ uploading: false });
                } else {
                  this.props.pushMessage({
                    message: res.error.msg,
                    type: "error"
                  });
                }
              })
              .catch(error => {
                console.log(error);
                this.setState({
                  uploading: false,
                  files: []
                });
                this.props.pushMessage({
                  message: error.message,
                  type: "error"
                });
              });
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };

  content = () => {
    switch (true) {
      case this.state.uploading:
        return <Spinner />;
      default:
        return <Buttons onChange={this.onChange} accepts={this.props.accepts} disabled={!this.props.administrator} />;
    }
  };

  render() {
    return (
      <div style={{ minWidth: "120px", height: "100%", minHeight: "120px" }}>
        <div
          style={{ display: "flex", justifyContent: "center", height: "100%", minHeight: "120px", minWidth: "120px" }}
        >
          {this.content()}
        </div>
      </div>
    );
  }
  async solrUpload(file, msgId, bucket, tenant) {
    const this2 = this;
    const cog2Id = this.props.cognitoUser.signInUserSession.idToken.jwtToken;
    const solrFunction = this.solrFunction;

    return new Promise((resolve, reject) => {
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = function(e) {
        let data = e.target.result;
        let uint8array = new Uint8Array(data);
        let detectedEncoding = encoding.detect(uint8array);
        const fileExt = file.name
          .split(".")
          .pop()
          .toLowerCase();
        let xblob;
        if (detectedEncoding === "UTF8" && fileExt === "csv") {
          // CSV UTF8 leave as is
          xblob = file.slice(0, file.size, "application/csv;charset=UTF-8");
        } else {
          let workbook;
          if (fileExt === "csv") {
            // CSV process as string
            var matches = detect(uint8array);
            var str = iconv.decode(uint8array, matches[0].charsetName);
            workbook = xlsx.read(str, { type: "string" });
          } else {
            // Other process as byte array
            var oututf8Array = encoding.convert(uint8array, {
              to: "UTF8", // to_encoding
              from: detectedEncoding, // from_encoding
              bom: false
            });
            workbook = xlsx.read(oututf8Array, { type: "array", skipHeader: "true" });
          }
          let sheet = workbook.Sheets[workbook.SheetNames[0]];
          let csv = xlsx.utils.sheet_to_csv(sheet);

          // let csvBOM = "\ufeff" + csv;
          xblob = new Blob([csv], { type: "application/csv;charset=UTF-8" });
        }

        /* let formData = new FormData(); */

        Storage.put(environment + "/" + this2.props.connection.publicChatbotProps.data.GUID + ".csv", xblob, {
          contentType: "application/octet-stream",
          bucket: bucket
        })
          .then(res => {
            console.log(res);
            solrFunction(this2.props.connection.publicChatbotProps.data.GUID, cog2Id, msgId, bucket, tenant)
              .then(res => {
                resolve({ result: { msg: "Solr op. completed" } });
              })
              .catch(err => {
                this2.props.pushMessage({
                  message: UPLOAD_FAILED,
                  type: "error"
                });
                this2.setState({ uploading: false });
              });
          })
          .catch(err => {
            this2.props.pushMessage({
              message: UPLOAD_FAILED,
              type: "error"
            });
            this2.setState({ uploading: false });
          });
        console.log("finished");
      };
    });
  }

  async SQSUploadPolling(collection) {
    const this2 = this;
    let key = environment + "-" + collection;
    Amplify.Auth.currentCredentials().then(credentials => {
      const sqs = new SQS({
        apiVersion: "2012-11-05",
        credentials: Amplify.Auth.essentialCredentials(credentials)
      });

      const params = {
        QueueUrl: config.SQS_UPLOAD_QUEUE + "/" + key,
        MaxNumberOfMessages: 10,
        WaitTimeSeconds: 20
      };
      sqs.receiveMessage(params, function(err, data) {
        if (err) {
          this2.props.pushMessage({
            message: UPLOAD_FAILED,
            type: "error"
          });
          this2.setState({ uploading: false, collection: null, polling: 10 });
          return;
        }
        for (let msg of data.Messages) {
          let msgBody = JSON.parse(msg.Body);
          if (msgBody.msgId === this2.state.msgId) {
            if (msgBody.status) {
              this2.props.pushMessage({
                message: UPLOADED_FILE,
                type: "success"
              });
            } else {
              this2.props.pushMessage({
                message: msgBody.msg,
                type: "error"
              });
            }
            this2.setState({ uploading: false, collection: null, polling: 10 });
            var deleteParams = {
              QueueUrl: config.SQS_UPLOAD_QUEUE + "/" + key /* required */,
              ReceiptHandle: msg.ReceiptHandle /* required */
            };
            sqs.deleteMessage(deleteParams, function(err, data) {
              if (err) console.log(err, err.stack); // an error occurred
            });
            break;
          }
        }
        this2.setState((prevState, props) => ({ polling: prevState.polling - 1 }));
      });
    });
  }

  async solrFunction(collection, jwtToken, msgId, uploadDestination, tenant) {
    let destination;
    switch (uploadDestination) {
      case "faq-documents":
        destination = "solr";
        break;
      case "survey-document":
        destination = "survey";
        break;
      default:
        destination = null;
    }
    let data = {
      body: {
        data: {
          collection: collection,
          msgId: msgId,
          tenant: tenant
        }
      },
      headers: {
        InvocationType: "Event",
        Authorization: jwtToken
      }
    };
    // TODO API Call
    console.log("SOLR API Call", data);
    let apiResponse = await API.post(config.AWS_API_NAME, destination, data);
    console.log("SOLR API Response", apiResponse);
    return apiResponse;
  }
}

function mapStateToProps(state) {
  return {
    cognitoUser: state.auth.cognitoUser,
    connection: state.connections
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(
      {
        pushMessage,
        generatePublicChatbotSnippet
      },
      dispatch
    ),
    dispatch
  };
}

Uploader = connect(
  mapStateToProps,
  mapDispatchToProps
)(Uploader);

export default Uploader;
